import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { COACH_CONFIG } from '../../coachconfig';




const GiftSuccess = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { apiBaseUrl } = COACH_CONFIG;

  useEffect(() => {
    const handleGiftSuccess = async () => {
      try {
        // Get session ID from URL params
        const urlParams = new URLSearchParams(location.search);
        const sessionId = urlParams.get('session_id');
        
        if (!sessionId) {
          setError('No session ID found');
          setIsLoading(false);
          return;
        }

        // Get gift data from localStorage
        const giftData = localStorage.getItem('pendingGift');
        if (!giftData) {
          setError('No gift data found');
          setIsLoading(false);
          return;
        }

        const parsedGiftData = JSON.parse(giftData);

        // POST gift data to trigger notifications
            const response = await fetch(`${apiBaseUrl}/gifts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...parsedGiftData,
            sessionId,
            status: 'completed'
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to process gift');
        }

        // Clear localStorage
        localStorage.removeItem('pendingGift');
        
        setIsLoading(false);
      } catch (err) {
        console.error('Error processing gift success:', err);
        setError(err.message);
        setIsLoading(false);
      }
    };

    handleGiftSuccess();
  }, [location]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Processing your gift purchase...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="text-center max-w-md mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-2xl p-8 mb-6">
            <div className="text-6xl mb-4">⚠️</div>
            <h1 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h1>
            <p className="text-red-700">{error}</p>
          </div>
          <a
            href="/"
            className="inline-block bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold py-3 px-6 rounded-xl transition duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center max-w-2xl mx-auto">
        {/* Success Animation Container */}
        <div className="bg-white border border-purple-200 rounded-3xl p-12 mb-8 shadow-2xl">
          {/* Animated Success Icon */}
          <div className="mx-auto w-24 h-24 bg-gradient-to-r from-purple-600 to-purple-700 rounded-full flex items-center justify-center mb-8 animate-pulse">
            <div className="text-4xl">🎁</div>
          </div>
          
          {/* Success Title */}
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            Gift Purchase Successful! ✨
          </h1>
          
          {/* Success Message */}
          <div className="space-y-6 mb-8">
            <p className="text-xl text-gray-600">
              Thank you for your gift purchase! The recipient will be notified and can start their wellness journey with us.
            </p>
            
            {/* What happens next section */}
            <div className="bg-purple-50 border border-purple-100 rounded-xl p-6">
              <p className="text-purple-700 font-semibold mb-3">What happens next:</p>
              <ul className="text-gray-700 text-left space-y-2">
                <li className="flex items-center">
                  <span className="text-purple-600 mr-2">•</span>
                  The recipient will receive a notification
                </li>
                <li className="flex items-center">
                  <span className="text-purple-600 mr-2">•</span>
                  They can claim their gift package
                </li>
                <li className="flex items-center">
                  <span className="text-purple-600 mr-2">•</span>
                  You'll receive a confirmation email
                </li>
              </ul>
            </div>
          </div>
          
          {/* Celebration Emojis */}
          <div className="flex justify-center space-x-3 mb-8">
            <span className="text-3xl animate-bounce" style={{ animationDelay: '0ms' }}>🎁</span>
            <span className="text-3xl animate-bounce" style={{ animationDelay: '100ms' }}>💜</span>
            <span className="text-3xl animate-bounce" style={{ animationDelay: '200ms' }}>✨</span>
            <span className="text-3xl animate-bounce" style={{ animationDelay: '300ms' }}>🎉</span>
            <span className="text-3xl animate-bounce" style={{ animationDelay: '400ms' }}>💪</span>
          </div>
        </div>
        
        {/* Action Button */}
        <div className="space-y-4">
          <a
            href="/"
            className="inline-block bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold py-4 px-8 rounded-xl transition duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            Return to Home 🏠
          </a>
          
          <div className="text-sm text-gray-500 mt-4">
            <p>Your gift recipient will be notified shortly! 📧</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftSuccess; 